import { GetQueueRequestsCount } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetQueueRequestsCount
  extends BaseHttpService<GetQueueRequestsCount.Model>
  implements GetQueueRequestsCount
{
  async get(params: GetQueueRequestsCount.Params): Promise<GetQueueRequestsCount.Model> {
    return await this.request('get', undefined, params);
  }
}
